import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/fontawesome-free-solid";

const SearchBar = ({
  value,
  onChange,
  placeholder = "Search users",
  useMUIcons = true,
}) => {
  return (
    <div className="relative max-sm:w-full">
      {useMUIcons ? (
        <SearchIcon
          className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400"
          fontSize="small"
        />
      ) : (
        <FontAwesomeIcon
          icon={faSearch}
          className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm"
        />
      )}
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="pl-11 pr-4 py-2.5 border border-content rounded-lg text-sm w-full sm:w-72 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent placeholder:text-content"
      />
    </div>
  );
};

export default SearchBar;
